import { FC } from "react";

export const BusinessIcon: FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(0,24) scale(0.1,-0.1)" fill="#000000" stroke="none">
        <path
          d="M20 120 l0 -90 100 0 100 0 0 70 0 70 -50 0 c-43 0 -50 3 -50 20 0
17 -7 20 -50 20 l-50 0 0 -90z m80 60 c0 -5 -13 -10 -30 -10 -16 0 -30 5 -30
10 0 6 14 10 30 10 17 0 30 -4 30 -10z m0 -40 c0 -5 -13 -10 -30 -10 -16 0
-30 5 -30 10 0 6 14 10 30 10 17 0 30 -4 30 -10z m100 -40 l0 -50 -40 0 -40 0
0 50 0 50 40 0 40 0 0 -50z m-100 0 c0 -5 -13 -10 -30 -10 -16 0 -30 5 -30 10
0 6 14 10 30 10 17 0 30 -4 30 -10z m0 -40 c0 -5 -13 -10 -30 -10 -16 0 -30 5
-30 10 0 6 14 10 30 10 17 0 30 -4 30 -10z"
        />
        <path
          d="M140 120 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10 -11 0
-20 -4 -20 -10z"
        />
        <path
          d="M140 80 c0 -5 9 -10 20 -10 11 0 20 5 20 10 0 6 -9 10 -20 10 -11 0
-20 -4 -20 -10z"
        />
      </g>
    </svg>
  );
};
